














































































































































































































































































import { computed, defineComponent } from "@vue/composition-api";
import FixedFooterLayout from "@/components/Atoms/Layout/FixedFooter/index.vue";
import PageHeader from "@/components/Molecules/PageHeader/index.vue";
import LoadingView from "@/components/Molecules/LoadingView/index.vue";
import Button from "@/components/Atoms/Button/index.vue";
import OccLabel from "@/components/Atoms/OccLabel/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import Caption from "@/components/Atoms/Typography/Caption/index.vue";
import ListTable from "@/components/Molecules/ListTable/index.vue";
import ConfirmModal from "@/components/Organisms/modals/ConfirmModal/index.vue";

import { getPartnerEntryUsers, bulkUpdateSelectionStatus } from "@/api";
import { useRequest } from "@/helpers/hooks/useRequest";
import {
  getDisplayEventStatus,
  getDisplayEventType,
  getDisplayScheduleSpan,
  getDisplaySelectionStatus
} from "@/helpers/partnerEntryUsers";
import { formatDate } from "@/helpers/date-helper";
import { pathQueryValueToArray } from "@/helpers/router-helper";
import { useToggle } from "@/helpers/hooks/useToggle";
import { PartnerEntryUserSelectionStatus } from "@/api/types";
import { useRoute, useRouter } from "@/router";

export default defineComponent({
  components: {
    FixedFooterLayout,
    PageHeader,
    LoadingView,
    Button,
    Caption,
    ListTable,
    OccLabel,
    OccButton,
    ConfirmModal
  },
  name: "SelectedPartnerEntryUsers",
  setup() {
    const route = useRoute();
    const router = useRouter();
    const selectionStatus = route.query.selectionStatus as
      | PartnerEntryUserSelectionStatus
      | undefined;
    const partnerEntryUserIds = pathQueryValueToArray(
      route.query.partnerEntryUserIds
    )?.map(partnerEntryUserId => Number(partnerEntryUserId));

    if (!partnerEntryUserIds) {
      throw "query に partnerEntryUserIds を指定してください。";
    }

    if (!selectionStatus) {
      throw "query に selectionStatus を指定してください。";
    }

    const [{ data: partnerEntryUsers, loading: isGetLoading }] = useRequest(
      () =>
        getPartnerEntryUsers({
          partner_entry_user_ids: partnerEntryUserIds,
          limit: partnerEntryUserIds.length,
          order: "desc"
        }),
      { immediate: true }
    );

    const [{ loading: isUpdateLoading }, runUpdate] = useRequest(() =>
      bulkUpdateSelectionStatus({
        partner_entry_user_ids: validPartnerEntryUserIds.value,
        selection_status: selectionStatus
      })
    );

    const validPartnerEntryUserIds = computed(() => {
      if (!partnerEntryUsers.value) {
        return [];
      }
      return partnerEntryUsers.value.records
        .filter(partnerEntryUser =>
          partnerEntryUser.possible_transitions.includes(selectionStatus)
        )
        .map(partnerEntryUser => partnerEntryUser.partner_entry_user.id);
    });

    const invalidPartnerEntryUserIdsCount = computed(() => {
      if (!partnerEntryUsers.value) {
        return 0;
      }
      return (
        partnerEntryUsers.value.records.length -
        validPartnerEntryUserIds.value.length
      );
    });
    const headers = [
      {
        name: "応募者名",
        subHeaders: [{ name: "識別コード" }, { name: "カナ" }],
        sizeInner: "100px",
        minSizeContainer: "180px"
      },
      {
        name: "大学",
        subHeaders: [{ name: "卒年" }, { name: "学部・学年" }],
        sizeInner: "100px",
        minSizeContainer: "220px"
      },
      {
        name: "応募経路",
        subHeaders: [
          { name: "イベント種別" },
          { name: "応募日時", order: "asc" }
        ],
        minSizeContainer: "250px"
      },
      {
        name: "応募スケジュール",
        subHeaders: [{ name: "スケジュール開催日" }],
        minSizeContainer: "250px"
      },
      {
        name: "イベントステータス",
        sizeInner: "130px",
        minSizeContainer: "170px"
      },
      {
        name: "変更前",
        sizeInner: "100px",
        minSizeContainer: "100px"
      },
      {
        name: "変更後",
        sizeInner: "100px",
        minSizeContainer: "100px"
      }
    ];

    const [
      isShowChangeConfirmModal,
      toggleIsShowChangeConfirmModal
    ] = useToggle();
    const [
      isShowChangeSuccessModal,
      toggleIsShowChangeSuccessModal
    ] = useToggle();

    const onConfirmChange = async () => {
      toggleIsShowChangeConfirmModal();
      await runUpdate();
      toggleIsShowChangeSuccessModal();
    };

    const onConfirmSuccess = () => {
      toggleIsShowChangeSuccessModal();
      router.push({
        name: "Entries"
      });
    };

    const backToPartnerEntryUsers = () => {
      router
        .push({
          name: "Entries"
        })
        .catch(err => err);
    };

    return {
      getDisplayEventStatus,
      getDisplayEventType,
      getDisplaySelectionStatus,
      getDisplayScheduleSpan,
      formatDate,

      selectionStatus,
      partnerEntryUserIds,
      validPartnerEntryUserIds,
      invalidPartnerEntryUserIdsCount,

      partnerEntryUsers,
      headers,
      isGetLoading,
      isUpdateLoading,

      isShowChangeConfirmModal,
      toggleIsShowChangeConfirmModal,
      isShowChangeSuccessModal,
      toggleIsShowChangeSuccessModal,
      onConfirmChange,
      onConfirmSuccess,
      backToPartnerEntryUsers
    };
  }
});
